export const LANG_COUNTRY = ':langCountry';
export const LANG_COUNTRY_VALUE_REGEXP = /^[a-zA-Z]{2,3}(-[a-zA-Z]{2})?$/;
export const FROM = ':from';
export const TO = ':to';
export const FROM_TO = ':fromTo';

/*
footer types for cashing
 */
export const FOOTER_TYPE_SEND_LANDING = '/send-money';
export const FOOTER_TYPE_REQUEST_LANDING = '/request';
export const FOOTER_TYPE_SIMPLE = '/simple';
export const FOOTER_TYPE_DEFAULT = '/default';
